import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from "vue-toastification/composition";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from "@/libs/i18n";
import store from "@/store";

export default function sectionListQuery() {
    const toast = useToast()
    const sectionTable = ref(null)
    const perPage = ref(10)
    const totalSections = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const tableColumns = [
        { key:'name', label: i18n.t('Name'), sortable: true},
        { key: 'actions', label: i18n.t('Actions') },
    ]

    const dataMeta = computed(() => {
        const localItemsCount = sectionTable.value ? sectionTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalSections.value,
        }
    });

    const refetchData = function() {
        sectionTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchSections = function(ctx, callback) {
        store.dispatch('sections/fetchSections', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            const { sections, total } = response.data
            callback(sections)
            totalSections.value = total
        })
        .catch(error => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching sections list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        fetchSections,
        tableColumns,
        perPage,
        currentPage,
        totalSections,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        sectionTable,
        refetchData,
    }
}